import { useContext } from "react";
import DataContext from "../../context/data-context";

import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Footer from "./Footer";

import NavigationBar from "./NavigationBar";
import heroBkgDark from "../../assets/img/hero-bkg-dark.webp";
import LoadingSpinnerWrapper from "../UI/LoadingSpinnerWrapper";

export default function Layout({ children }) {
  const { loadingData } = useContext(DataContext);

  return (
    <div className="bg-gradient-to-br from-stone-900">
      <img
        className="fixed top-0 left-0 object-cover w-screen h-screen -z-10"
        src={heroBkgDark}
      />
      <Navbar />
      <div className="grid gap-4 mx-2 lg:mx-4 md:grid-cols-6">
        <NavigationBar />
        <Sidebar />
        {loadingData ? (
          <div className="container lg:col-span-5">
            <LoadingSpinnerWrapper />
          </div>
        ) : (
          <div className="lg:col-span-5">{children}</div>
        )}
      </div>
      <Footer />
    </div>
  );
}
